import { AbstractControl } from '@angular/forms';

export function IDLengthLegalRepresentativeValidator(control: AbstractControl) {
  if (!control.value || !control.parent) {
    return null;
  }
  const idType = control.parent.get('documentType')?.value;

  if (idType === 'other' || !idType) {
    return null;
  }

  if (idType === 'national id') {
    const exactLengthEight = new RegExp(/^[0-9]{8,8}$/).test(control.value);
    if (!exactLengthEight) {
      return {
        dniExactLength: true,
      };
    }
  } else if (idType === 'ruc') {
    const exactLengthEleven = new RegExp(/^[0-9]{11,11}$/).test(control.value);
    if (!exactLengthEleven) {
      return {
        rucExactLength: true,
      };
    }
  } else if (idType === 'foreigner card') {
    const exactLengthNine = new RegExp(/^[0-9]{9,9}$/).test(control.value);
    if (!exactLengthNine) {
      return {
        ceExactLength: true,
      };
    }
  } else {
    const betweenFiveAndFifteen = new RegExp(/^[A-Za-z0-9]{5,15}$/).test(control.value);
    if (!betweenFiveAndFifteen) {
      return {
        passportLengthRange: true,
      };
    }
  }
  return null;
}

